import React from "react";
import PageBody from "Common/Custom/PageBody";
import AddItemBtn from "Common/Custom/AddItemBtn";
import { HeadingOne } from "Common/Custom/HeadingOne";
import PagesListTable from "./Components/PagesListTable";
import { CanAccessThisPage } from "Common/RoleVerify";

const PagesSettings = () => {
    return (
        <CanAccessThisPage menu_access={["can_access"]}>
            <PageBody
                card={true}
                headerchildren={
                    <>
                        <HeadingOne>Dynamic Pages</HeadingOne>
                        <div className="d-flex gap-2 flex-wrap mt-sm-0 mt-2">
                            <AddItemBtn url="add-page" title="Add Page" />
                        </div>
                    </>
                }
            >
                <div className="col-12">
                    <PagesListTable />
                </div>
            </PageBody>
        </CanAccessThisPage>
    );
};

export default PagesSettings;
